export default __webpack_public_path__ + "static/media/aircraft_workshop_01_1k.994c4795.hdr";